import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Drawer,
  Table,
  Divider,
} from "antd";
import CarePlanWizard from "./CarePlanWizard";
import SurgicalInterventionSummary from "../surgical_intervention/SurgicalInterventionSummary";
import { EditOutlined } from "@ant-design/icons";

import { all as AllCarePlan } from "../../api/CarePlan";

import moment from "moment";

const CarePlanList = (props) => {
  const title = "Soins";
  const { surgicalIntervention } = props;
  const [carePlans, setCarePlans] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    showSizeChanger: true,
    position: ["topRight"],
  });
  const [loading, setLoading] = useState(false);
  const [showModalForm, setShowModalForm] = useState(false);
  const [selectedCarePlan, setSelectedCarePlan] = useState(null);

  useEffect(() => {
    if (!!props.surgicalIntervention) {
      fetchCarePlans(pagination);
    }
  }, [props.surgicalIntervention]);

  const fetchCarePlans = async function (pagination) {
    setLoading(true);

    AllCarePlan({
      current: pagination.current,
      pageSize: pagination.pageSize,
      sort: "action_time,1",
      q: {
        "surgical_intervention_id": surgicalIntervention.id,
      },
    })
      .then((data) => {
        setLoading(false);
        setCarePlans(data.results);
        setPagination({
          ...pagination,
          total: data.total,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onClose = () => {
    setShowModalForm(false);
    setSelectedCarePlan(null);
    props.onClose();
  };

  const onCloseFormModal = () => {
    setShowModalForm(false);
    setSelectedCarePlan(null);
  };

  const onEdit = (id) => {
    let carePlan = carePlans.find((item) => item.id === id);
    setSelectedCarePlan(carePlan);
    setShowModalForm(true);
  };

  const columns = [
    {
      title: "Saisie",
      dataIndex: "index",
      width: "20%",
    },
    {
      title: "Date",
      dataIndex: "action_time",
      render: (record) => {
        if (!record) {
          return null;
        }
        return moment(record).format("DD/MM/YYYY");
      },
    },
    {
      render: (data) => {
        return (
          <Space>
            <Button
              type="primary"
              shape="circle"
              size="large"
              icon={<EditOutlined />}
              onClick={() => onEdit(data.id)}
            />
          </Space>
        );
      },
      width: "20%",
      align: "right",
    },
  ];
  const dataSource = carePlans.map((item, key) => {
    item['index'] = key + 1;
    return item;
  });

  return (
    <>
      <CarePlanWizard
        carePlan={selectedCarePlan}
        surgicalIntervention={surgicalIntervention}
        visible={showModalForm}
        onClose={onCloseFormModal}
        refresh={() => fetchCarePlans(pagination)}
      />
      <Drawer
        title={title}
        placement="left"
        closable={true}
        onClose={onClose}
        visible={props.visible}
        width={800}
        key="left"
      >
        <SurgicalInterventionSummary surgicalIntervention={surgicalIntervention} />
        <Divider />

        <div>
          <Row className="mb-3" style={{ textAlign: "right" }}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                onClick={() => setShowModalForm(true)}
              >
                Nouvelle saisie
              </Button>
            </Col>
          </Row>

          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={pagination}
            onChange={fetchCarePlans}
            loading={loading}
          />
        </div>
      </Drawer>
    </>
  );
};

export default CarePlanList;
